module.exports = __webpack_public_path__ + "static/media/pryde-symbol.4cbf2f09.png";